'use strict';

import { isHistoryEntered, paymentTiming } from './pulsePaymentTiming.js';

function isPaymentEvent(event) {
  return event && (event.type === 'payment_recorded' || event.type === 'retainage_release_paid');
}

function timelinePaymentRow(event, payload) {
  if (!isPaymentEvent(event)) return null;
  const rows = (payload && payload.payments) || [];
  const id = String(event.id || '');
  const m = id.match(/^pay:([^:]+):(\d+)$/);
  if (m) {
    const found = rows.find((p) => String(p.source) === m[1] && Number(p.id) === Number(m[2]));
    if (found) return found;
  }
  const rec = event.record || {};
  return rows.find((p) => Number(p.id) === Number(rec.id)
    && Number(p.pay_app_id) === Number(rec.pay_app_id)) || null;
}

function timelinePaymentChip(event, payload) {
  const row = timelinePaymentRow(event, payload);
  if (!row) return { history: false, chip: null };
  const history = isHistoryEntered({
    paidAt: row.paid_at,
    submittedAt: row.submitted_at,
    dueDate: row.due_date,
    termsDays: payload && payload.terms_days,
    paymentTerms: payload && payload.payment_terms,
  });
  if (history) return { history: true, chip: null };
  return { history: false, chip: paymentTiming({ dueDate: row.due_date, paidAt: row.paid_at }) };
}

export { timelinePaymentRow, timelinePaymentChip, isPaymentEvent };
